import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable,Subject } from 'rxjs';
import { CryptUtilService } from 'src/app/shared/services/crypt-util.service';


interface sidebarCount {
  psgMain: number;
  psgNested: number;
}

@Injectable({
  providedIn: 'root'
})
export class PsgSidebarService {

  sideBarCounts: sidebarCount = {
    psgMain: null,
    psgNested: null
  }
  stepperContents:any={};
  private psgSidebarIndex = new BehaviorSubject<Object>(this.sideBarCounts);
  public psgCurFormStatus :Subject<boolean>=new Subject();
  public psgSidebarItem = new BehaviorSubject<Object>(this.stepperContents);

  currentIndex = this.psgSidebarIndex.asObservable();

  constructor(private cryptoUtilService: CryptUtilService) { }

  setIndex(indexes: sidebarCount) {
  //  console.log('set index called', indexes);
    this.psgSidebarIndex.next(indexes);
  }  
  getIndex(): Observable<any> {
   // console.log('get index called');
    return this.psgSidebarIndex.asObservable();
  }
  setCurFormStatus(data) {
    this.psgCurFormStatus.next(data);
  }
  setSidebarData(data) {
    this.cryptoUtilService.setItem('stepperContents', data, 'SESSION');
    this.psgSidebarItem.next(data);
  }


}
